const months = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
];
export function localize(date) {
    return `${date.getDate()} ${months[date.getMonth() % 12]} ${date.getFullYear()}`;
}
export function formatTime(date, delimiter = ':') {
    return `${('0' + date.getHours()).slice(-2)}${delimiter}${('0' + date.getMinutes()).slice(-2)}`;
}
